import { CollisionDetection, pointerWithin } from "@dnd-kit/core";
import { isLevelLinkDropId, LEVEL_PANEL_DROP_ID } from "./resolve-drop-target";

/**
 * `pointerWithin`, который знает про панель уровней. dnd-kit ищет приёмник по
 * прямоугольникам, а не по тому, что видно на экране, поэтому над панелью он нашёл
 * бы и строку дерева под ней. Над панелью целью может быть только её звено, а над
 * её фоном — сама панель, которая бросок не принимает.
 */
export const levelPanelCollision: CollisionDetection = (args) => {
  const collisions = pointerWithin(args);
  const panel = collisions.find(({ id }) => id === LEVEL_PANEL_DROP_ID);

  if (!panel) {
    return collisions;
  }

  const links = collisions.filter(({ id }) => isLevelLinkDropId(String(id)));

  return links.length ? links : [panel];
};
